import axios from 'axios';

export default {
    name: 'q-room-detail-popover',
    props: {
        roomDetails: {
            type: Object,
            default: () => {}
        },
        guestDetails: {
            type: Object,
            default: () => {}
        },
        tags: {
            type: Array,
            default: () => []
        },
        propertyId: {
            type: [Number, String],
            default: ''
        },
        propertyTimeZone: {
            type: String,
            default: 'America/Chicago'
        },
        trigger: {
            type: [Number, String],
            default: ''
        },
        comments: {
            type: Array,
            default: () => []
        },
        tickets: {
            type: Array,
            default: () => []
        },
        showActionMenu: {
            type: Boolean,
            default: true
        },
        showGuestDetails: {
            type: Boolean,
            default: false
        },
        showComments: {
            type: Boolean,
            default: false
        },
        showTickets: {
            type: Boolean,
            default: true
        },
        showGuestCallback: {
            type: Boolean,
            default: true
        },
        hover: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'md'
        },
        open: {
            type: Boolean,
            default: false
        },
        align: {
            type: String,
            default: 'left',
        },
        position: {
            type: String,
            default: 'bottom',
        },
        locale: {
            type: String,
            default: 'en'
        },
        containerElement: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            userId: null,
            roomDetailsData: this.roomDetails,
            guestDetailsData: this.guestDetails,
            comment: '',
            alignment: 'left',
            positioning: 'bottom',
            componentHeight: 250,
            componentWidth: 290,
            messages: [],
            actionMenuOpen: false,
            quickReplyOpen: false,
            expandGuestInfo: true,
            expandTickets: true,
            expandComments: true,
            expandedStates: {
                info: true,
                tickets: true,
                comments: true
            },
            quickReplies: [],
            showCreateRequest: false,
            todoOptions: [
                {
                    label: this.$t('HC_COMPLAINT'),
                    value: 'complaint'
                },
                {
                    label: this.$t('HC_REQUEST'),
                    value: 'request'
                },
                {
                    label: this.$t('HC_ROOM_NOTICE'),
                    value: 'room_notice'
                },
                {
                    label: this.$t('HC_WORK_ORDER'),
                    value: 'work_order'
                }
            ],
            requestType: null,
            itemOptions: [],
            moodOptions: [],
            workOrderIssues: [],
            departmentUsers: [],
            departments: [],
            assignTypes: [
                {
                    id: 1,
                    label: this.$t('HC_DEPARTMENT') // need to localize
                },
                {
                    id: 2,
                    label: this.$t('HC_PERSON') // need to localize
                },
                {
                    id: 0,
                    label: this.$t('HC_ANYONE') // need to localize
                }
            ],
            requestedByOptions: [
                {
                    id: 0,
                    label: this.$t('HC_STAFF_MEMBER') // need to localize
                },
                {
                    id: 1,
                    label: this.$t('HC_HOTEL_GUEST') // need to localize
                }
            ],
            requestLoading: false,
            roomNotices: this.tags,
            roomNotice: {
                endDate: new Date(),
                issue: null,
                notes: '',
                startDate: new Date()
            },
            complaint: {
                checkInDate: new Date(),
                checkOutDate: new Date(),
                guestEmail: '',
                guestLoyalty: '',
                guestMood: null,
                guestName: '',
                guestPhone: '',
                inHouse: !!this.roomDetails.tokenId,
                problem: null,
                notes: '',
                tokenId: this.roomDetails.tokenId
            },
            request: {
                assignType: null,
                department: null,
                due: new Date(),
                item: null,
                notes: '',
                person: null,
                requestedBy: null
            },
            workOrder: {
                assignType: null,
                department: null,
                due: new Date(),
                item: null,
                issue: null,
                notes: '',
                person: null,
                requestedBy: null
            },
            ticketsList: this.tickets,
            containerElement: this.containerElement
        };
    },
    computed: {
        tagsList() {
            let tags = this.roomNotices;

            // Add occupancy status.
            if (this.roomDetailsData) {
                if (this.roomDetailsData.occupancy) {
                    tags = [
                        ...tags,
                        this.roomDetailsData.occupancy.name.toLowerCase()
                    ];
                }

                // Add cleanliness status.
                if (this.roomDetailsData.cleaning) {
                    tags = [
                        ...tags,
                        this.roomDetailsData.cleaning.name.toLowerCase()
                    ];
                }

                // Remove duplicates from the array
                tags = [...new Set(tags)];
            }

            return tags;
        },
        stayDetails() {
            let dateDisplay = '';

            if (
                this.roomDetailsData &&
                this.roomDetailsData.reservations[0]
            ) {
                // Arrival info.
                const arrival = this.$moment(
                    this.roomDetailsData.reservations[0]
                        .arrivalDate
                );
                const arrivalMonth = arrival.format('MMM');
                const arrivalDay = arrival.format('D');
                const arrivalYear = arrival.format('YYYY');

                // Departure info.
                const departure = this.$moment(
                    this.roomDetailsData.reservations[0]
                        .departureDate
                );
                const departureMonth = departure.format('MMM');
                const departureDay = departure.format('D');
                const departureYear = departure.format('YYYY');

                dateDisplay += arrivalMonth + ' ' + arrivalDay;

                if (arrivalYear !== departureYear) {
                    dateDisplay += ', ' + arrivalYear;
                }

                if (arrivalMonth === departureMonth) {
                    dateDisplay += '-' + departureDay;
                } else {
                    dateDisplay += ' - ' + departureMonth + ' ' + departureDay;
                }

                dateDisplay += ', ' + departureYear;
            }

            return dateDisplay;
        },
        hasGuestCallback() {
            if (this.tickets.length) {
                const callback = this.tickets.find(
                    (ticket) => ticket.type === 'callback'
                );

                return !!callback;
            }

            return false;
        },
        filteredReplies() {
            const comment = this.comment.toLowerCase();

            return this.quickReplies.filter((reply) => {
                const replyText = reply.toLowerCase();
                return replyText.match(comment);
            });
        },
        itemOptionsList() {
            let list = [];

            if (
                this.itemOptions[0] &&
                this.itemOptions[0].options === undefined
            ) {
                this.itemOptions.forEach((item) => {
                    list.push({
                        id: parseInt(item.id),
                        label: item.display_name
                    });
                });
            } else {
                list = this.itemOptions;
            }

            return list;
        },
        selectedAssignType() {
            switch (this.requestType) {
                case 'request':
                case 'work_order':
                    return this.assignTypes[0];
                default:
                    return null;
            }
        },
        selectedRequestedBy() {
            switch (this.requestType) {
                case 'request':
                    return this.requestedByOptions[1];
                case 'work_order':
                    return this.requestedByOptions[0];
                default:
                    return null;
            }
        },
        selectedDepartment() {
            if (this.departments) {
                switch (this.requestType) {
                    case 'request':
                        return this.departments.find((department) => {
                            return parseInt(department.id) === 4;
                        });
                    case 'work_order':
                        return this.departments.find((department) => {
                            return parseInt(department.id) === 2;
                        });
                    default:
                        return null;
                }
            }

            return null;
        },
        validateToDo() {
            const selected = this.requestType;

            if (!selected) {
                return false;
            }

            switch (selected.value) {
                case 'room_notice':
                    return (
                        this.roomNotice.issue &&
                        this.roomNotice.startDate &&
                        this.roomNotice.endDate
                    );
                case 'complaint':
                    return (
                        this.complaint.problem &&
                        this.complaint.guestName &&
                        this.complaint.guestMood
                    );
                case 'work_order':
                    return (
                        this.workOrder.item &&
                        this.workOrder.issue &&
                        this.workOrder.requestedBy &&
                        this.workOrder.due &&
                        ((this.workOrder.assignType &&
                            this.workOrder.assignType.id === 0) ||
                            (this.workOrder.assignType &&
                                this.workOrder.assignType.id === 1 &&
                                this.workOrder.department) ||
                            (this.workOrder.assignType &&
                                this.workOrder.assignType.id === 2 &&
                                this.workOrder.person))
                    );
                case 'request':
                    return (
                        this.request.item &&
                        this.request.requestedBy &&
                        this.request.due &&
                        ((this.request.assignType &&
                            this.request.assignType.id === 0) ||
                            (this.request.assignType &&
                                this.request.assignType.id === 1 &&
                                this.request.department) ||
                            (this.request.assignType &&
                                this.request.assignType.id === 2 &&
                                this.request.person))
                    );
                default:
                    return false;
            }
        }
    },
    methods: {
        // Handle the onmouseover and onmouseleave events.
        onHoverToggle(value) {
            // This should happen on hover regardless of click or hover.
            this.setAlignment();
            this.setPositioning();
            // Only check this if hover enabled.
            if (this.hover) {
                this.open = value;
            }
        },
        // Set the alignment left or right based on window.
        setAlignment() {
            if (this.align === 'left' || this.align === 'right') {
                const offsetLeft = this.$refs.trigger.getBoundingClientRect()
                    .left;
                const windowWidth = window.innerWidth;
                this.alignment =
                    windowWidth - offsetLeft < this.componentWidth
                        ? 'right'
                        : 'left';
            } else {
                const offsetTop = this.$refs.trigger.getBoundingClientRect()
                    .top;
                const windowHeight = window.innerHeight;
                this.alignment =
                    windowHeight - offsetTop < this.componentHeight
                        ? 'bottom'
                        : 'top';
            }
        },
        // Set positioning top or bottom based on window.
        setPositioning() {
            if (this.position === 'top' || this.position === 'bottom') {
                const offsetTop = this.$refs.trigger.getBoundingClientRect()
                    .top;
                const windowHeight = window.innerHeight;
                this.positioning =
                    windowHeight - offsetTop < this.componentHeight
                        ? 'top'
                        : 'bottom';
            } else {
                const offsetLeft = this.$refs.trigger.getBoundingClientRect()
                    .left;
                const windowWidth = window.innerWidth;
                this.positioning =
                    windowWidth - offsetLeft < this.componentWidth
                        ? 'left'
                        : 'right';
            }
        },
        // Get room data.
        async getRoomData() {
            // Function to get the cookie
            function getCookie(cname) {
                let name = cname + '=';
                let ca = document.cookie.split(';');
                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return '';
            }

            // Example of data to send to api
            const data = {
                roomsIds: [this.roomDetailsData.qRoomId]
            };

            // api url
            const url = `${
                process.env.VUE_APP_INTEGRATIONS_API_URL
            }/vendors/properties/statuses/${this.propertyId}/rooms`;

            try {
                const response = await axios.post(url, data, {
                    headers: {
                        Authorization: 'Bearer ' + getCookie('QV2Auth')
                    }
                });

                this.roomDetailsData = response.data.data.rooms
                    ? response.data.data.rooms[0]
                    : this.roomDetails;
            } catch (error) {
                console.log(error);
            }
        },
        getIcon(ticketType) {
            switch (ticketType) {
                case 'complaint':
                    return 'face-frown-outline';
                case 'hk_request':
                    return 'concierge-bell-outline';
                case 'callback':
                    return 'phone-outline';
                case 'work_order':
                    return 'hammer-outline';
            }
        },
        onClickTicket(ticket) {
            switch (ticket.type) {
                case 'complaint':
                    return `/complaints/complaints_view.php?id=${ticket.id}`;
                case 'hk_request':
                    return `/tasks/hk_request.php?id=${ticket.id}`;
                case 'callback':
                    return `/tasks/task_callback.php?id=${ticket.id}`;
                case 'work_order':
                    return `/tasks/workorder.php?id=${ticket.id}`;
            }
        },
        getHowLongAgo(date) {
            // Get current date.
            const currentDate = this.$moment().utc();

            // Get ticket posted date.
            const ticketDate = this.$moment.utc(date);

            // Get how many days difference between now and when it was posted.
            const yearsDiff = currentDate.diff(ticketDate, 'years');
            const monthsDiff = currentDate.diff(ticketDate, 'months');
            const daysDiff = currentDate.diff(ticketDate, 'days');
            const hoursDiff = currentDate.diff(ticketDate, 'hours');
            const minutesDiff = currentDate.diff(ticketDate, 'minutes');

            // Handle years
            if (yearsDiff) {
                if (yearsDiff === 1) {
                    return this.$t('HC_ONE_YEAR_AGO');
                } else {
                    return this.$t('HC_X_YEARS_AGO')
                        .toString()
                        .replace('{years}', yearsDiff);
                }
            }

            // Handle months
            if (monthsDiff) {
                if (monthsDiff === 1) {
                    return this.$t('HC_ONE_MONTH_AGO');
                } else {
                    return this.$t('HC_X_MONTHS_AGO')
                        .toString()
                        .replace('{months}', monthsDiff);
                }
            }

            // Handle days
            if (daysDiff) {
                if (daysDiff === 1) {
                    return this.$t('HC_ONE_DAY_AGO');
                } else {
                    return this.$t('HC_X_DAYS_AGO')
                        .toString()
                        .replace('{days}', daysDiff);
                }
            }

            // Handle hours
            if (hoursDiff) {
                if (hoursDiff === 1) {
                    return this.$t('HC_ONE_HOUR_AGO');
                } else {
                    return this.$t('HC_X_HOURS_AGO')
                        .toString()
                        .replace('{hours}', hoursDiff);
                }
            }

            // Handle minutes
            if (minutesDiff) {
                if (minutesDiff === 1) {
                    return this.$t('HC_ONE_MINUTE_AGO');
                } else {
                    return this.$t('HC_X_MINUTES_AGO')
                        .toString()
                        .replace('{minutes}', minutesDiff);
                }
            }

            if (minutesDiff === 0) {
                return this.$t('HC_A_MOMENT_AGO');
            }
        },
        async createCallback() {
            try {
                const formData = new FormData();
                formData.append('area', this.roomDetailsData.qRoomId);
                formData.append('whattodo', 'createcallback');

                this.open = false;

                await axios.post('/includes/jquery_close_vrroom.php', formData);

                if (typeof window.select_buildRoomsGrid !== 'undefined') {
                    window.select_buildRoomsGrid(this.propertyId, 1);
                }

            } catch (error) {
                console.log(error);
            }
        },
        async getChatMessages() {
            if (this.showComments && this.roomDetails.tokenId) {
                try {
                    const formData = new FormData();
                    formData.append('funcname', 'get_messages');
                    formData.append('token_id', this.roomDetails.tokenId);

                    const response = await axios.post(
                        '/includes/chat_api.php',
                        formData
                    );

                    // Handle errors not thrown from chat_api.php.
                    if (response.data.result !== undefined && response.data.result.error_message) {
                        throw new Error(response.data.result.error_message);
                    }

                    // Grab messages from response or default to empty.
                    const messages = response.data.result.messages || [];

                    // Update message list in the ui.
                    this.createMessageList(messages);
                } catch (error) {
                    console.log(error);
                }
            }
        },
        async sendChatMessage(event) {
            // We prevent this event because of newline with ENTER in textarea.
            if (event && event.type === 'keydown') {
                event.preventDefault();
            }

            // If we have an established Connect room and quick reply isn't open,
            // then proceed with submitting the post.
            if (this.roomDetails.tokenId && this.comment && !this.quickReplyOpen) {
                try {
                    // Build the post form.
                    const formData = new FormData();
                    formData.append('funcname', 'send_message_to_guest');
                    formData.append('stay_id', this.roomDetails.tokenId);
                    formData.append('content', this.comment);
                    formData.append('sender_id', this.userId);

                    // Perform post of new message.
                    const response = await axios.post(
                        '/includes/chat_api.php',
                        formData
                    );

                    // Handle errors not thrown from chat_api.php.
                    if (response.data.result.error_message) {
                        throw new Error(response.data.result.error_message);
                    }

                    // Reset the comment field to empty.
                    this.comment = '';

                    // Get the messages list again.
                    await this.getChatMessages();

                    // After messages are updated, scroll to bottom again.
                    this.scrollToConnectBottom();
                } catch (error) {
                    console.log(error);
                }
            }
        },
        createMessageList(messages) {
            const messageList = [];

            Object.values(messages).forEach((message) => {
                // Set initial data object with message data.
                let messageData = {
                    id: message.id,
                    isPropertyEmployee: message.sender_type === 'user',
                    isSent: !!message.sent,
                    isSystemMessage: message.sender_type === 'system',
                    message: message.content,
                    timestamp: message.sent || message.created,
                    user: {
                        firstName: 'Auto-Reply',
                        id: 'system-message',
                        lastName: ''
                    }
                };

                // Set data for when the message is from a Quore user.
                if (message.sender_type === 'user') {
                    messageData.user.firstName = message.user_first_name;
                    messageData.user.lastName = message.user_last_name;
                    messageData.user.initials =
                        messageData.user.firstName[0] +
                        messageData.user.lastName[0];
                }

                // Set data for when the message is from a Guest.
                if (message.sender_type === 'guest') {
                    messageData.user.firstName = message.guest_first_name;
                    messageData.user.lastName = message.guest_last_name;
                }

                // Set initials for user after determining appropriate
                // first and last name.
                messageData.user.initials =
                    messageData.user.firstName[0] +
                    messageData.user.lastName[0];

                // TODO: Get property avatar or user avatar if exists.
                messageData.user.src = '';

                // We'll want to use an icon instead of initials if it's
                // a system message and the property doesn't have an avatar.
                if (messageData.isSystemMessage) {
                    messageData.user.icon = 'property-fill';
                }

                // Set a user ID for the message sender.
                if (message.sender_id) {
                    messageData.user.id = message.sender_id;
                }

                // Push the appropriately formatted comment to the messages list.
                messageList.push(messageData);
            });

            this.messages = messageList;
        },
        scrollToConnectBottom() {
            // Get comments scrollable container.
            const commentsContainer = document.getElementById('comments-container');
            // Scroll to the bottom of the scrollable area to show most recent message.
            commentsContainer.scroll({
                top: commentsContainer.scrollHeight,
                behavior: 'smooth'
            });
        },
        toggleQuickReply() {
            // Toggle the quick reply to the opposite true/false.
            this.quickReplyOpen = !this.quickReplyOpen;

            // Handle expansion and condensing of accordions accordingly.
            if (this.quickReplyOpen) {
                // Clear the field.
                this.comment = '';

                // Save the current state of expanded categories.
                this.expandedStates.info = this.expandGuestInfo;
                this.expandedStates.tickets = this.expandTickets;
                this.expandedStates.comments = this.expandComments;

                // Set Open Tickets and Guest Info to NOT expanded.
                this.expandGuestInfo = false;
                this.expandTickets = false;

                document.getElementById('comment-field').focus();
            } else {
                // Set expanded categories back to saved values.
                this.expandGuestInfo = this.expandedStates.info;
                this.expandTickets = this.expandedStates.tickets;
                this.expandComments = this.expandedStates.comments;
            }
        },
        onClickEditConnectGuest() {
            // Right now we only link to Connect from this link.
            // TODO: We could provide a form to edit in the popover.
            window.location.href = '/guest/overview.php';
        },
        onSelectQuickReply(reply) {
            // When selecting a quick reply, perform toggle actions
            // and set the textarea comment text to the quick reply text.
            this.toggleQuickReply();
            this.comment = reply;
        },
        resizeTextarea() {
            // Unfortunately, we needed to use a fake div (#hidden-text) to mimic
            // what the textarea looks like. This allows us to determine an
            // appropriate height for the textarea as content changes in the textarea.
            // The need for the textarea to be only 32px height also made this necessary
            // as other methods for adjusting height didn't work below the browser's
            // set minimum height of a textarea despite our styles. Height "auto" wouldn't work.
            const textarea = document.getElementById('comment-field');
            const hidden = document.getElementById('hidden-text');
            textarea.style.height = hidden.offsetHeight + 'px';
        },
        openRequest() {
            this.showCreateRequest = !this.showCreateRequest;
            this.actionMenuOpen = false;
        },
        closeRequest() {
            // Reset room details popover to initial state.
            this.showCreateRequest = false;
            this.quickReplyOpen = false;
            this.actionMenuOpen = false;

            // Reset all form options.
            this.itemOptions = [];
            this.moodOptions = [];
            this.workOrderIssues = [];

            // Reset request type.
            this.requestType = null;

            // Reset room notice info.
            this.roomNotice.issue = null;
            this.roomNotice.startDate = new Date();
            this.roomNotice.endDate = new Date();
            this.roomNotice.notes = '';

            // Reset complaint info.
            this.complaint.guestName = '';
            this.complaint.guestEmail = '';
            this.complaint.guestPhone = '';
            this.complaint.guestMood = null;
            this.complaint.guestLoyalty = '';
            this.complaint.problem = null;
            this.complaint.checkInDate = new Date();
            this.complaint.checkOutDate = new Date();
            this.complaint.notes = '';

            // Reset work order info.
            this.workOrder.assignType = null;
            this.workOrder.department = null;
            this.workOrder.person = null;
            this.workOrder.due = new Date();
            this.workOrder.item = null;
            this.workOrder.issue = null;
            this.workOrder.notes = '';

            // Reset request info.
            this.request.assignType = null;
            this.request.department = null;
            this.request.person = null;
            this.request.due = new Date();
            this.request.item = null;
            this.request.notes = '';
        },
        async onCreateRequestSubmit() {
            this.requestLoading = true;

            const type = this.requestType.value;
            const formData = new FormData();
            formData.append('property_id', this.propertyId);
            formData.append('user_id', this.userId);
            formData.append('area_id', this.roomDetailsData.qRoomId);
            formData.append('area_name', this.roomDetailsData.roomName);

            switch (type) {
                case 'complaint':
                    formData.append('token_id', this.roomDetails.tokenId);
                    formData.append('problem', this.complaint.problem.id);
                    formData.append('guest_name', this.complaint.guestName);
                    formData.append('guest_phone', this.complaint.guestPhone);
                    formData.append('guest_email', this.complaint.guestEmail);
                    formData.append(
                        'guest_loyalty',
                        this.complaint.guestLoyalty
                    );
                    formData.append('guest_mood', this.complaint.guestMood.id);
                    formData.append(
                        'check_in_date',
                        this.$moment(this.complaint.checkInDate).format(
                            'YYYY-MM-DD'
                        )
                    );
                    formData.append(
                        'check_out_date',
                        this.$moment(this.complaint.checkOutDate).format(
                            'YYYY-MM-DD'
                        )
                    );
                    formData.append('notes', this.complaint.notes);
                    formData.append('in_house', 2); // 2 since area_id is specified

                    // We need to returns object instead of redirecting to Complaints page.
                    formData.append('source', 'dashboard');

                    try {
                        const response = await axios.post(
                            '/api/client/common/postComplaint.php',
                            formData
                        );

                        const complaint = response.data.complaint;

                        if (complaint) {
                            await this.updateTickets(complaint, 'complaint');

                            this.closeRequest();
                            this.requestLoading = false;

                            this.handlePulse('complaint');
                        } else {
                            // Else, it will return null.
                            // Display error message of duplicate already created.
                        }
                    } catch (error) {
                        console.log(error);
                    }

                    break;
                case 'request':
                    formData.append('item_id', this.request.item.id);
                    formData.append(
                        'assign_type',
                        this.request.assignType.id
                    );
                    formData.append('occupied', this.request.requestedBy.id);
                    formData.append('notes', this.request.notes);
                    formData.append(
                        'due_date',
                        this.$moment(this.request.due).format('YYYY-MM-DD')
                    );

                    // Add department ID if department is selected assign type.
                    if (this.request.assignType.id === 1) {
                        formData.append(
                            'department',
                            this.request.department.id
                        );
                    }

                    // Add user ID if person is selected assign type.
                    if (this.request.assignType.id === 2) {
                        formData.append('person', this.request.person.id);
                    }

                    // call function to add work order
                    try {
                        const response = await axios.post(
                            '/api/client/common/postRequest.php',
                            formData
                        );
                        const request = response.data.request;

                        if (request.id) {
                            await this.updateTickets(
                                request.id,
                                'hk_request'
                            );

                            this.closeRequest();
                            this.requestLoading = false;

                            this.handlePulse('request');
                        } else {
                            console.log(request.error);
                        }
                    } catch (error) {
                        console.log('error posting work order:', error);
                    }
                    break;
                case 'room_notice':
                    formData.append('issue', this.roomNotice.issue.id);
                    formData.append(
                        'start_date',
                        this.$moment(this.roomNotice.startDate).format(
                            'YYYY-MM-DD'
                        )
                    );
                    formData.append(
                        'end_date',
                        this.$moment(this.roomNotice.endDate).format(
                            'YYYY-MM-DD'
                        )
                    );
                    formData.append('notes', this.roomNotice.notes);
                    formData.append('send_push', true);

                    // call function to add room notice
                    try {
                        const response = await axios.post(
                            '/api/client/common/postRoomNotice.php',
                            formData
                        );
                        const roomNotice = response.data.room_notice;

                        if (roomNotice) {
                            // If a room notice object with ID came back then it was successful.
                            const roomNoticeFormData = new FormData();
                            roomNoticeFormData.append(
                                'property_id',
                                this.propertyId
                            );
                            roomNoticeFormData.append(
                                'room_ids',
                                JSON.stringify([this.roomDetailsData.qRoomId])
                            );

                            // Close request form, clear fields, and GET room notices again.
                            const roomNotices = await axios.post(
                                '/api/client/common/getRoomNoticesByRoomIds.php',
                                roomNoticeFormData
                            );

                            if (roomNotices.data.notices) {
                                const notices = [];

                                roomNotices.data.notices.forEach(notice => {
                                    notices.push({
                                        id: notice.id,
                                        name: notice.display_name,
                                        isNew:
                                            parseInt(notice.id) ===
                                            parseInt(roomNotice.id)
                                    });
                                });

                                this.roomNotices = notices;
                            }

                            this.closeRequest();
                            this.requestLoading = false;

                            this.handlePulse('room_notice');
                        } else {
                            // Else, it will return null.
                            // Display error message of duplicate already created.
                        }
                    } catch (error) {
                        console.log('error posting room notice:', error);
                    }
                    break;
                case 'work_order':
                    formData.append('item_id', this.workOrder.item.id);
                    formData.append('issue_id', this.workOrder.issue.id);
                    formData.append(
                        'assign_type',
                        this.workOrder.assignType.id
                    );
                    formData.append('occupied', this.workOrder.requestedBy.id);
                    formData.append('notes', this.workOrder.notes);
                    formData.append(
                        'due_date',
                        this.$moment(this.workOrder.due).format('YYYY-MM-DD')
                    );

                    // Add department ID if department is selected assign type.
                    if (this.workOrder.assignType.id === 1) {
                        formData.append(
                            'department',
                            this.workOrder.department.id
                        );
                    }

                    // Add user ID if person is selected assign type.
                    if (this.workOrder.assignType.id === 2) {
                        formData.append('person', this.workOrder.person.id);
                    }

                    // call function to add work order
                    try {
                        const response = await axios.post(
                            '/api/client/common/postWorkOrder.php',
                            formData
                        );
                        const workOrder = response.data.work_order;

                        if (workOrder.id) {
                            await this.updateTickets(
                                workOrder.id,
                                'work_order'
                            );

                            this.closeRequest();
                            this.requestLoading = false;

                            this.handlePulse('work_order');
                        } else {
                            console.log(workOrder.error);
                        }
                    } catch (error) {
                        console.log('error posting work order:', error);
                    }
                    break;
            }
        },
        async onSelectToDo(selected) {
            this.requestType = selected;
            this.itemOptions = [];
            this.roomNotice.issue = null;
            this.complaint.problem = null;
            this.workOrder.item = null;
            this.workOrder.issue = null;
            this.request.item = null;

            if (!this.requestType) {
                return;
            }

            let response = [];
            const formData = new FormData();
            formData.append('property_id', this.propertyId);
            formData.append('area_id', this.roomDetailsData.qRoomId);

            // Based on which To Do type was selected, get next list for dropdown.
            switch (selected.value) {
                case 'complaint':
                    try {
                        // Go get guest info if a Connect token ID exists.
                        if (this.roomDetails.tokenId) {
                            await this.getStayDetails();
                        }

                        // Go get the property's list of complaint problems.
                        response = await axios.post(
                            '/api/client/common/getComplaintProblemsByPropertyId.php',
                            formData
                        );

                        // Set problem options for complaints.
                        this.itemOptions = response.data.items;

                        // Get the moods for another dropdown.
                        const moods = await axios.post(
                            '/api/client/common/getComplaintMoods.php'
                        );

                        moods.data.items.forEach((mood) => {
                            mood.label = mood.display_name;
                        });

                        // Set the mood. ;)
                        this.moodOptions = moods.data.items;
                    } catch (error) {
                        console.log(error);
                    }
                    break;
                case 'room_notice':
                    try {
                        // Go get the property's list of room notices (issues).
                        response = await axios.post(
                            '/api/client/common/getRoomNoticeListByPropertyId.php',
                            formData
                        );

                        // Set item options for room notices.
                        this.itemOptions = response.data.items;
                    } catch (error) {
                        console.log(error);
                    }
                    break;
                case 'request':
                    try {
                        // Set defaults for request.
                        this.request.requestedBy = this.requestedByOptions[1]; // Hotel Guest
                        this.request.assignType = this.assignTypes[0]; // Department

                        // Go get the property's list of complaint problems.
                        response = await axios.post(
                            '/api/client/common/getHousekeepingItemsByPropertyId.php',
                            formData
                        );

                        // Set problem options for requests.
                        this.itemOptions = response.data.items;

                        // Get data for departments and users.
                        await this.getSharedData();

                        // Set default department.
                        this.request.department = this.departments.find(
                            department => {
                                return parseInt(department.id) === 4; // Housekeeping
                            }
                        );
                    } catch (error) {
                        console.log(error);
                    }
                    break;
                case 'work_order':
                    try {
                        // Set defaults for request.
                        this.workOrder.requestedBy = this.requestedByOptions[0]; // Staff Member
                        this.workOrder.assignType = this.assignTypes[0]; // Department

                        // Go get the property's list of complaint problems.
                        response = await axios.post(
                            '/api/client/common/getItemsByRoomId.php',
                            formData
                        );

                        const items = [];
                        let section = {
                            group: '',
                            options: []
                        };

                        // Loop through the items to form the groups.
                        response.data.items.forEach((item) => {
                            // If new section and previous section is populated,
                            // push the section to the array then clear the section
                            // so it can be populated for the new section.
                            if (item.section_name !== section.group) {
                                if (section.group) {
                                    items.push({ ...section });
                                }
                                section.group = item.section_name;
                                section.options = [];
                            }
                            // Push each item to the appropriate section options.
                            // Only push items that have a "label" value.
                            if (item.label) {
                                section.options.push(item);
                            }
                        });

                        // Pushes the last section after finishing the loop.
                        items.push({ ...section });

                        // Set problem options for complaints.
                        this.itemOptions = items;

                        // Get data for work order issues, departments, and users.
                        await Promise.all([
                            axios.post(
                                '/api/client/common/getWorkOrderIssues.php'
                            ),
                            this.getSharedData()
                        ]).then((values) => {
                            const issues = values[0];

                            issues.data.issues.forEach((issue) => {
                                issue.label = issue.display_name;
                            });

                            // Set the work order issues.
                            this.workOrderIssues = issues.data.issues;
                        });

                        // Set default department.
                        this.workOrder.department = this.departments.find(
                            department => {
                                return parseInt(department.id) === 2; // Engineering
                            }
                        );
                    } catch (error) {
                        console.log(error);
                    }
                    break;
                default:
                    return;
            }
        },
        async getSharedData() {
            const usersFormData = new FormData();
            usersFormData.append('property_id', this.propertyId);
            usersFormData.append('filter', 'tasks_new');

            // Get the issues, departments, and users for the next several dropdown.
            await Promise.all([
                axios.post('/api/client/common/getDepartments.php'),
                axios.post(
                    '/api/client/common/getDepartmentUsersByPropertyId.php',
                    usersFormData
                )
            ]).then(values => {
                const departments = values[0];
                const departmentUsers = values[1];

                departments.data.departments.forEach((department) => {
                    department.label = department.display_name;
                });

                // Set the work order departments.
                this.departments = departments.data.departments;

                // Variables for setting up optgroups for users.
                const users = [];
                let department = {
                    group: '',
                    options: []
                };

                // Loop through to create the optgroups for users.
                departmentUsers.data.users.forEach((user) => {
                    // If new department and previous department is populated,
                    // push the department to the array then clear the department
                    // so it can be populated for the new department.
                    if (
                        user.translated_department !== department.group
                    ) {
                        if (department.group) {
                            users.push({ ...department });
                        }
                        department.group =
                            user.translated_department;
                        department.options = [];
                    }
                    // Push each item to the appropriate department options.
                    department.options.push(user);
                });

                // Push last department to the users list.
                users.push({ ...department });

                // Set the work order users by property ID.
                this.departmentUsers = users;
            });
        },
        async getStayDetails() {
            try {
                const formData = new FormData();
                formData.append('funcname', 'get_stay_details');
                formData.append('token_id', this.roomDetails.tokenId);

                const response = await axios.post(
                    '/includes/chat_api.php',
                    formData
                );

                const stayDetails = response.data.result;

                // Handle errors not thrown from chat_api.php.
                if (stayDetails !== undefined && stayDetails.error_message) {
                    throw new Error(stayDetails.error_message);
                }

                if (stayDetails && stayDetails.user_name) {
                    this.complaint.guestName = stayDetails.user_name;
                }

                if (stayDetails && stayDetails.cell_phone) {
                    this.complaint.guestPhone = stayDetails.cell_phone;
                }

                if (stayDetails && stayDetails.email) {
                    this.complaint.guestEmail = stayDetails.email;
                }

                if (stayDetails && stayDetails.check_in) {
                    this.complaint.checkInDate = this.$moment(stayDetails.check_in).toDate();
                }

                if (stayDetails && stayDetails.check_out) {
                    this.complaint.checkOutDate = this.$moment(stayDetails.check_out).toDate();
                }
            } catch (error) {
                console.log(error);
            }
        },
        handlePulse(type) {
            // Get .pulse class elements.
            const elements = document.querySelectorAll('.pulse');

            // If there are any pulse elements.
            if (elements && elements.length) {
                // A pulse element means that THIS room has a new notice NOW.
                // So we need to update the grid room box to show room notice.
                const gridRoom = document.getElementById(
                    'room-' + this.roomDetailsData.qRoomId
                );
                const classes = gridRoom.classList;

                // Depending on what was added, handle each type accordingly.
                switch (type) {
                    case 'room_notice':
                        // Room Notice (room_notice)
                        // If the room doesn't already have a To Do color, make it green
                        // by adding the room notice class.
                        if (
                            classes.contains('roombox_unsel') ||
                            classes.contains('roombox_unsel_active')
                        ) {
                            gridRoom.classList.remove();
                            gridRoom.classList.add('roomnoticeroombox_sel');
                        }
                        break;
                    case 'complaint':
                        // Complaint (complaint)
                        // If the room doesn't already have a To Do color, make it red
                        // by adding the complaint class.
                        if (
                            !classes.contains('smsroombox_sel') &&
                            !classes.contains('callbackroombox_sel')
                        ) {
                            gridRoom.classList.remove();
                            gridRoom.classList.add('complaintsroombox_sel');
                        }
                        break;
                    case 'request':
                        // Complaint (complaint)
                        // If the room doesn't already have a To Do color, make it red
                        // by adding the complaint class.
                        if (
                            !classes.contains('smsroombox_sel') &&
                            !classes.contains('callbackroombox_sel') &&
                            !classes.contains('complaintsroombox_sel')
                        ) {
                            gridRoom.classList.remove();
                            gridRoom.classList.add('guestrequestroombox_sel');
                        }
                        break;
                    case 'work_order':
                        // Complaint (complaint)
                        // If the room doesn't already have a To Do color, make it red
                        // by adding the complaint class.
                        if (
                            !classes.contains('smsroombox_sel') &&
                            !classes.contains('callbackroombox_sel') &&
                            !classes.contains('complaintsroombox_sel') &&
                            !classes.contains('guestrequestroombox_sel')
                        ) {
                            gridRoom.classList.remove();
                            gridRoom.classList.add('workordersroombox_sel');
                        }
                        break;
                    default:
                        break;
                }

                // After 4.5 seconds (3 pulses at 1.5 seconds), remove the class.
                setTimeout(() => {
                    elements.forEach(element => {
                        element.classList.remove('pulse');
                    });
                }, 4500);
            }
        },
        async updateTickets(id, type) {
            // If a room notice object with ID came back then it was successful.
            const formData = new FormData();
            formData.append('property_id', this.propertyId);
            formData.append(
                'room_ids',
                JSON.stringify([this.roomDetailsData.qRoomId])
            );

            // Close request form, clear fields, and GET room notices again.
            const openTickets = await axios.post(
                '/api/client/common/getAllToDosByRoomIds.php',
                formData
            );

            // If open tickets are returned for this room.
            if (openTickets.data.tickets) {
                const tickets = [];

                // Loop through and add the isNew flag to the
                // recently added ticket.
                openTickets.data.tickets.forEach(ticket => {
                    if (
                        parseInt(ticket.id) === parseInt(id) &&
                        ticket.type === type
                    ) {
                        tickets.unshift({
                            ...ticket,
                            isNew: true
                        });
                    } else {
                        tickets.push({
                            ...ticket,
                            isNew: false
                        });
                    }
                });

                // Sort the tickets temporarily to show the new ticket
                // at the top of the Open Tickets section.
                tickets.sort((a, b) => {
                    return a.id === id ? -1 : b.id === id ? 1 : 0;
                });

                this.ticketsList = [...tickets];
            }
        },
        checkContainer() {
            if (this.containerElement) {
                const container = document.querySelector(this.containerElement);
                if (container) {
                    const observer = new MutationObserver(mutations => {
                        mutations.forEach(mutation => {
                            if (mutation.removedNodes && mutation.removedNodes.length > 0) {
                                mutation.removedNodes.forEach(removedNode => {
                                    if (removedNode === this.$el || removedNode.contains(this.$el)) {
                                        observer.disconnect();
                                        this.$destroy();
                                    }
                                });
                            }
                        });
                    });

                    observer.observe(container, { childList: true, subtree: true });
                }
            }
        }
    },
    watch: {
        open() {
            // When open is set to true and they have Connect with messages.
            // We want to scroll to the bottom of the comments to start.
            // NOTE: This can be removed if we have newest comment at the top.
            if (this.open && this.showComments && this.messages.length) {
                // Needs half a second to render the comments component.
                // This will guarantee the comments element exists.
                setTimeout(() => this.scrollToConnectBottom(), 500);
            }

            // Clear all the things if popover is closed.
            if (!this.open) {
                this.closeRequest();
            }
        },
        comment() {
            setTimeout(this.resizeTextarea, 100);
        }
    },
    mounted() {
        // Set the user ID.
        const auth = JSON.parse(window.localStorage.getItem('authenticated'));
        this.userId = auth.user.id;

        // If size large, change the component height and width for calculations.
        if (this.size === 'sm') {
            this.componentHeight = 140;
            this.componentWidth = 160;
        }
        // If size large, change the component height and width for calculations.
        if (this.size === 'lg') {
            this.componentHeight = 250; // updated from 550 because of bad experience in QV2.
            this.componentWidth = 440;
        }

        // Set the initial alignment and positioning.
        this.setAlignment();
        this.setPositioning();

        // Get Connect messages.
        // Call get messages from qv2 chat api.
        this.getChatMessages();

        // Get Quick Replies
        const replies = [];
        const storedReplies = window.localStorage.getItem('quick-replies');

        if (storedReplies) {
            JSON.parse(storedReplies).forEach(reply => {
                replies.push(reply.message);
            });
        }

        this.quickReplies = replies;

        this.checkContainer();
    }
};
